import { captureException } from '@sentry/vue';
import { CategoryAssetTypeEnum } from '@/enum/category_asset_types';
import { snapchat } from '@/gen/proto/protos';
import IAssetsV3 = snapchat.bitmoji.api.IAssetsV3;

const BASE_ASSET_OVERRIDES_PATH: string = './asset_overrides';

const getPathToOverrideFile = (assetTypeEnumVal: string): string => {
  switch (assetTypeEnumVal) {
    case CategoryAssetTypeEnum.TRAITS:
      return `${BASE_ASSET_OVERRIDES_PATH}/avatar_traits_builder/avatar_traits.json`;
    case CategoryAssetTypeEnum.OUTFITS:
      return `${BASE_ASSET_OVERRIDES_PATH}/outfit_builder/data_v2.json`;
    case CategoryAssetTypeEnum.MIX_AND_MATCH_ITEMS:
      return `${BASE_ASSET_OVERRIDES_PATH}/split_clothing_builder/data.json`;
    default:
      throw Error(`Invalid override assets category: ${assetTypeEnumVal}`);
  }
};

const overrideAssetCategory = (
  assetTypeEnumVal: string,
  overrideData: any,
  assets: IAssetsV3,
): void => {
  switch (assetTypeEnumVal) {
    case CategoryAssetTypeEnum.TRAITS:
      assets.traits = overrideData;
      break;
    case CategoryAssetTypeEnum.OUTFITS:
      assets.outfits = overrideData;
      break;
    case CategoryAssetTypeEnum.MIX_AND_MATCH_ITEMS:
      assets.mix_and_match_items = overrideData;
      break;
    default:
      throw Error(`Invalid override assets category: ${assetTypeEnumVal}`);
  }
};

const applyAssetOverrideForCategory = (
  assetTypeEnumVal: string,
  assets: IAssetsV3,
): Promise<any> => {
  return fetch(getPathToOverrideFile(assetTypeEnumVal))
    .then((response: Response) => {
      if (response.status === 200) {
        return response.json();
      }
      return Promise.reject(
        new Error(
          `Error retrieving override for assets category: ${assetTypeEnumVal}.` +
            `statusCode: ${response.status}`,
        ),
      );
    })
    .then((overrideData) => {
      overrideAssetCategory(assetTypeEnumVal, overrideData, assets);
      return null;
    });
};

const applyAssetOverrides = (assetOverrides: string[], assets: IAssetsV3): Promise<IAssetsV3> => {
  const overridePromises: Promise<any>[] = [];

  assetOverrides.forEach((assetTypeEnum) => {
    overridePromises.push(applyAssetOverrideForCategory(assetTypeEnum, assets));
  });

  return Promise.all(overridePromises)
    .then(() => {
      return assets;
    })
    .catch((e) => {
      captureException(e);
      return assets;
    });
};

export default {
  applyAssetOverrides,
};
